module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/goals-find-a-partner.json
// module id = 371
// module chunks = 16510204007368